import DrupalPage, {getServerSideProps as originalGetServerSideProps} from './[...path]';

export const getServerSideProps = originalGetServerSideProps;
export default DrupalPage;
